import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Divider,
    Stack,
    Flex,
    Text,
    useMultiStyleConfig,
    useBreakpointValue,
} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import PaymentIcons from './payment-icons'
import SocialIcons from '../social-icons'
import CountrySelector from '../../components/footer/country-selector'
import LegalLinks from './legal-links'
// import ApplicationIcons from './application-icons'
import {BrandLogoInverted, VerticalLineIcon} from '../icons'
import useUtils from '../../custom-hooks/use-utils-helper'
import {useLocation} from 'react-router-dom'
import {remCalc} from '@app/theme/_utils'

const CopyrightSection = ({data}) => {
    const styles = useMultiStyleConfig('Footer')

    const intl = useIntl()

    const location = useLocation()
    const {isCheckout, isCart, isMaintenance} = useUtils().currentPage(location.pathname)
    const isFooterLite = isCart || isCheckout || isMaintenance

    const footerData = data?.footer_bottom_group

    const copyrightGroup = footerData?.copyright_group
    const copyright = copyrightGroup?.copyright
    const vatNumber = copyrightGroup?.vat_number

    const breakpoint = useBreakpointValue({
        base: 'base',
        lg: 'lg',
    })

    return (
        <>
            {breakpoint === 'lg' && (
                <Box w="100%" {...styles.hideOnMobile}>
                    <Flex {...styles.paymentsLegalOuterContainer}>
                        {!isFooterLite && <Divider {...styles.dividerRule} />}

                        <Flex
                            {...styles.paymentsLegal}
                            paddingY={
                                isFooterLite
                                    ? 0
                                    : {
                                          base: 'medium.base',
                                          md: 'medium.md',
                                          lg: 'medium.lg',
                                          xl: 'medium.xl',
                                      }
                            }
                            gap={isFooterLite ? 0 : remCalc(40)}
                        >
                            <Flex {...styles.brandAndLinks}>
                                {!isFooterLite && (
                                    <Text {...styles.copyright} data-testid="copyright">
                                        {`${copyright} ${vatNumber}`}
                                    </Text>
                                )}

                                <Flex {...styles.footerLiteContainer}>
                                    {isFooterLite && (
                                        <BrandLogoInverted {...styles.footerBrandLogo} />
                                    )}

                                    <LegalLinks
                                        variant="horizontal"
                                        data-testid="legal-links"
                                        links={copyrightGroup?.copyright_links}
                                    >
                                        <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                                    </LegalLinks>
                                </Flex>
                            </Flex>

                            <Stack {...styles.socialAppPrivacyContainer}>
                                {!isFooterLite && (
                                    <Stack {...styles.socialAppPrivacy}>
                                        <Flex {...styles.socialApp}>
                                            <PaymentIcons
                                                data-testid="payment-icons"
                                                icons={footerData?.payment_icons}
                                            />

                                            <VerticalLineIcon {...styles.verticalLineIcon} />

                                            <SocialIcons
                                                data-testid="social-icons"
                                                icons={footerData?.social_icons}
                                            />

                                            <VerticalLineIcon {...styles.verticalLineIcon} />

                                            <CountrySelector intl={intl} />
                                        </Flex>
                                    </Stack>
                                )}
                            </Stack>
                        </Flex>
                    </Flex>
                </Box>
            )}
            {breakpoint === 'base' && (
                <Box w="100%" {...styles.hideOnDesktop}>
                    <Stack {...styles.mobileStack}>
                        <Flex {...styles.mobileVatLegalContainer}>
                            {!isFooterLite && (
                                <Text {...styles.copyright} data-testid="copyright">
                                    {`${copyright} ${vatNumber}`}
                                </Text>
                            )}

                            <LegalLinks
                                variant="horizontal"
                                data-testid="legal-links"
                                links={copyrightGroup?.copyright_links}
                            >
                                <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                            </LegalLinks>
                        </Flex>

                        {!isFooterLite && (
                            <Flex {...styles.mobileIconsContainer}>
                                <PaymentIcons
                                    data-testid="payment-icons"
                                    icons={footerData?.payment_icons}
                                />

                                <Flex {...styles.mobileSocialCountryContainer}>
                                    <SocialIcons
                                        data-testid="social-icons"
                                        icons={footerData?.social_icons}
                                    />

                                    <VerticalLineIcon {...styles.verticalLineIcon} />

                                    <CountrySelector intl={intl} />
                                </Flex>
                            </Flex>
                        )}
                    </Stack>
                </Box>
            )}
        </>
    )
}

CopyrightSection.propTypes = {
    data: PropTypes.shape({
        footer_bottom_group: PropTypes.shape({
            copyright_group: PropTypes.shape({
                copyright: PropTypes.string,
                vat_number: PropTypes.string,
                copyright_links: PropTypes.array,
            }),
            payment_icons: PropTypes.array,
            social_icons: PropTypes.array,
            app_download_icons: PropTypes.array,
        }),
    }),
}

export default CopyrightSection
